export const SET_HOVER = 'SET_HOVER';
export const SET_WIDGET_INFO = 'SET_WIDGET_INFO';
